import React, { useState, useEffect } from 'react';
import MenuHeader from './MenuHeader';
import Autocomplete from 'react-google-autocomplete';
import { useLoadScript } from '@react-google-maps/api';
import ZoneService from '../services/zone.service';
import { useNavigate, useLocation } from 'react-router-dom';
import UnavailableZoneService from '../services/unavailable_zones.service';
import useAuth from '../hooks/useAuth';
import useApi from '../hooks/useApi';
import { useNotifications } from '../context/NotificationProvider';
import { endpoints } from '../utils/utils';
import Modal from "react-modal";
import croix from "../assets/images/close-black.png";
import { usePrompt } from '../hooks/usePrompt';

import { useTranslation } from 'react-i18next';
import AddressService from '../services/address.service';
import HotelService from '../services/hotel.service';

const libraries = ['places'];
Modal.setAppElement("#root");

const hotelLookupCache = new Map();
const hotelFetchInFlight = new Map();

const customStyles = {
  content: {
    width: "33%",
    top: "50%",
    padding: "40px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};
const customStyles2 = {
  content: {
    width: "33%",
    top: "50%",
    padding: "0px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "0px",
    boxShadow: "none",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const EDIT_STEP_PATHS = [
  '/location-pro',
  '/fav-flypro',
  '/flypro-service',
  '/flypro-booking',
  '/payment'
];


const LocationPro = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('location');
  const { auth } = useAuth();
  const location = useLocation();
  const api = useApi();
  const [modalIsOpen, setIsOpen] = useState(false);
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });
  const [address, setAddress] = useState({
    street: '',
    city: '',
    zip_code: '',
    street_number: '',
    state: '',
    state_code: '',
    country: 'Switzerland',
    country_code: 'CH',
    lat: null,
    lng: null,
  });

  const [user, setUser] = useState();
  const [phone, setPhone] = useState("");
  const notify = useNotifications();
  const [email, setEmail] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [modalIsOpen2, setIsOpen2] = useState(false);
  const [hotelAddress, setHotelAddress] = useState();
  const [hotel, setHotel] = useState();
  const [checkingHotel, setCheckingHotel] = useState(false);
  const [showPostalField, setShowPostalField] = useState(false);
  const closeModal = () => setIsOpen(false);
  const closeModal2 = () => setIsOpen2(false);
  const openModal = () => setIsOpen(true);

  const openModal2 = () => {

    setIsOpen2(true)
  };
  const onContact = () => {
    navigate('/contact');
  };
  const handleEditClick = (e) => {
    e?.preventDefault?.();
    // Clear the current address so the form opens with empty inputs
    setAddress({
      street: '',
      city: '',
      zip_code: '',
      street_number: '',
      state: '',
      state_code: '',
      country: 'Switzerland',
      country_code: 'CH',
      lat: null,
      lng: null,
    });
    setShowPostalField(false);
    setIsEditing(true);
  };

  const onConfirm = () => {


    navigate('/hotels', { state: { hotel: hotel } });
  };
  const isEditBookingMode = sessionStorage.getItem("editBookingMode") === "true" || location?.state?.fromEditBooking;

  // Use `usePrompt` for navigation blocking
  usePrompt(
    isEditBookingMode,
    "Êtes-vous sûr de vouloir quitter la modification ? Vos changements ne seront pas enregistrés.",
    next => EDIT_STEP_PATHS.some(p => next.pathname.startsWith(p))
  );



  const handleSubmitEmail = async (e) => {
    e.preventDefault();

    const payload = {
      email: email,
      zip_code: address.zip_code,
      user_id: auth?.user?.id || null,
      zone_id: null
    };

    try {
      const response = await UnavailableZoneService.store(payload, api);

      if (response.success) {
        notify.success('Votre zone a été ajoutée avec succès');
      }
    } catch (error) {
      console.error('Error submitting email:', error);
    }
  };
  useEffect(() => {
    if (auth?.user?.phone) {
      setPhone(auth.user.phone ?? "");
    }
  }, [auth?.user]);
  useEffect(() => {
    const raw = sessionStorage.getItem('state');

    const savedState = JSON.parse(raw ?? '{}');

    if (savedState?.address) {
      setAddress(savedState.address);
    }

    if (savedState?.phone) {
      setPhone(savedState.phone);
    }
  }, []);

  function isZipCodeInRange(zipCode, range) {
    const ranges = range.split(',');
    const zip = parseInt(zipCode, 10);
    
    for (let element of ranges) {
      const trimmedElement = element.trim();
      
      if (trimmedElement.includes('-')) {
        const [start, end] = trimmedElement.split('-').map(Number);
        if (zip >= start && zip <= end) {
          return true;
        }
      } else {
        const singleZip = parseInt(trimmedElement, 10);
        if (zip === singleZip) {
          return true;
        }
      }
    }
    
    return false;
  }
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async () => {
      try {
        const response = await api.get(endpoints.getProfil);
        isMounted && setUser(response.data);
      } catch (err) {

      }
    }

    if(!address?.id) {
      getUsers();
    }

    return () => {
      isMounted = false;
      controller.abort();
    }
  }, [])


  const checkZipCodeInRange = async (zip_code) => {
    try {
      const zoneResponse = await ZoneService.index(null, api, auth?.accessToken ? false : true);

      if (zoneResponse) {
        const zipNumeric = parseInt(zip_code, 10);
        let isInRange = false;



        for (const zone of zoneResponse) {

          if (isZipCodeInRange(zipNumeric, zone.zip_code)) {
            isInRange = true;
            break;
          }
        }

        return isInRange;
      } else {
        console.error("Erreur lors de la récupération des zones.");
      }
    } catch (error) {
      console.error("Erreur lors de l'appel de ZoneService.index :", error);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (address) {
      const adrs = {
        address: address,
      };
      if (!address.zip_code) {
  notify.warn(t('please_enter_postal_code'));
        setShowPostalField(true);
        return;
      }
      // First, check if the address matches a known hotel (more specific)
      const hasHotelId = await checkAdress();
      if (hasHotelId) {
        notify.warn(t('hotel_address_short'));
        openModal();
        return;
      }

      // Then check zone coverage
      const isOneZone = await checkZipCodeInRange(address.zip_code);
      if (!isOneZone) {
        notify.warn(t('zone_not_served'));
        openModal2();
        return;
      }
      sessionStorage.setItem('address', JSON.stringify(adrs));
      const newBooking = {
        ...(JSON.parse(sessionStorage.getItem("newBooking") || "{}")),
        address,
        phone
      };
      sessionStorage.setItem("newBooking", JSON.stringify(newBooking));
      navigate('/fav-flypro', { state: { adress: address }, origin_flow: 'pro' });

    }
  };
  const checkAdress = async (addrOverride = null) => {
    // addrOverride: optional explicit address object to avoid read-after-set races
    const addrToUse = addrOverride || address;

    if (checkingHotel) return false; // guard concurrent checks
    setCheckingHotel(true);
    try {

      // Early check: if selected place has a Google place_id, try to find hotel by that place_id with caching/dedupe
      if (addrToUse?.place_id) {
        const placeKey = `place_${addrToUse.place_id}`;
        if (hotelLookupCache.has(placeKey)) {
          const cached = hotelLookupCache.get(placeKey);
          setHotel(cached);
          setHotelAddress(cached?.address ?? (cached?.address_id ? { id: cached.address_id } : null));
          setCheckingHotel(false);
          return !!cached;
        }
        if (!hotelFetchInFlight.has(placeKey)) {
          hotelFetchInFlight.set(placeKey, (async () => {
            try {
              const hotelsByPlace = await HotelService.index({ google_place_id: addrToUse.place_id, with: 'address' }, api, auth?.accessToken ? false : true);
              const h = Array.isArray(hotelsByPlace) && hotelsByPlace.length ? hotelsByPlace[0] : null;
              if (h) hotelLookupCache.set(placeKey, h);
              return h;
            } catch (e) {
              console.error('Error looking up hotel by place_id (pro):', e);
              return null;
            } finally {
              hotelFetchInFlight.delete(placeKey);
            }
          })());
        }
        const fetched = await hotelFetchInFlight.get(placeKey);
        if (fetched) {
          setHotel(fetched);
          setHotelAddress(fetched.address ?? (fetched.address_id ? { id: fetched.address_id } : null));
          setCheckingHotel(false);
          return true;
        }
      }

    const adressResponse = await AddressService.index({}, api, auth?.accessToken ? false : true);

      // Normalization helpers
      const stripAccents = (str = '') => ('' + str).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const normalizeStreet = (s = '') => stripAccents(('' + s).toLowerCase().replace(/[^a-z\s]/g, '').replace(/\s+/g, ' ').trim());
      const normalizeNumberWithSuffix = (n = '') => ('' + n).toLowerCase().replace(/[^0-9a-z]/g, '').trim();

      function levenshtein(a, b) {
        if (a === b) return 0;
        if (!a.length) return b.length;
        if (!b.length) return a.length;
        let v0 = new Array(b.length + 1).fill(0);
        let v1 = new Array(b.length + 1).fill(0);
        for (let i = 0; i <= b.length; i++) v0[i] = i;
        for (let i = 0; i < a.length; i++) {
          v1[0] = i + 1;
          for (let j = 0; j < b.length; j++) {
            let cost = a[i] === b[j] ? 0 : 1;
            v1[j + 1] = Math.min(v1[j] + 1, v0[j + 1] + 1, v0[j] + cost);
          }
          [v0, v1] = [v1, v0];
        }
        return v0[b.length];
      }

      let matchingAddress = null;
      let debugCount = 0;

      // narrow candidates to same zip, same city or same canton/state_code first to reduce work
      const normalizedAddrZip = (addrToUse.zip_code || '').toString().trim();
      const normalizedAddrCity = (addrToUse.city || '').toLowerCase().trim();
      const normalizedAddrState = ((addrToUse.state_code || addrToUse.state) || '').toString().toUpperCase().trim();
      const normalizedAddrStreet = normalizeStreet(addrToUse.street || '');

      let candidates = (adressResponse || []).filter(a => {
        const aZip = (a.zip_code || '').toString().trim();
        const aCity = (a.city || '').toLowerCase().trim();
        const aState = ((a.state_code || a.state) || '').toString().toUpperCase().trim();
        const aStreet = normalizeStreet(a.street || '');
        
        return (
          (aZip && normalizedAddrZip && aZip === normalizedAddrZip) ||
          (aCity && normalizedAddrCity && aCity === normalizedAddrCity) ||
          (aState && normalizedAddrState && aState === normalizedAddrState) ||
          (aStreet && normalizedAddrStreet && aStreet === normalizedAddrStreet)
        );
      }); 

      // If strict filtering yields no candidates (inconsistent DB fields like canton vs zip),
      // fall back to a looser filter: zip prefix, city contains, or same normalized street.
      if (!candidates.length) {
        const normAddrStreet = normalizeStreet(addrToUse.street || '');
        candidates = (adressResponse || []).filter(a => {
          const aZip = (a.zip_code || '').toString().trim();
          const aCity = (a.city || '').toLowerCase().trim();
          const aState = ((a.state_code || a.state) || '').toString().toUpperCase().trim();
          const streetMatch = normAddrStreet && normalizeStreet(a.street || '').includes(normAddrStreet);
          const zipPrefixMatch = normalizedAddrZip && aZip && (aZip.startsWith(normalizedAddrZip.slice(0, 3)) || normalizedAddrZip.startsWith(aZip.slice(0, 3)));
          const cityContains = normalizedAddrCity && aCity && (aCity.includes(normalizedAddrCity) || normalizedAddrCity.includes(aCity));
          return zipPrefixMatch || cityContains || streetMatch || (aState && normalizedAddrState && aState === normalizedAddrState);
        }); 
      }

      for (let responseAddress of candidates) {

        let respStreetRaw = responseAddress.street || '';
        let respNumberRaw = responseAddress.street_number || '';
        if (!respNumberRaw && respStreetRaw) {
          const matchLeading = respStreetRaw.match(/^\s*(\d+\w?)\s+[,\-]?\s*(.+)$/);
          const matchTrailing = respStreetRaw.match(/^(.+?)\s+[,\-]?\s*(\d+\w?)\s*$/);
          if (matchLeading) {
            respNumberRaw = matchLeading[1];
            respStreetRaw = matchLeading[2];
          } else if (matchTrailing) {
            respNumberRaw = matchTrailing[2];
            respStreetRaw = matchTrailing[1];
          }
        }
        const respStreet = normalizeStreet(respStreetRaw);
        const respNumber = normalizeNumberWithSuffix(respNumberRaw);
        const adrStreet = normalizeStreet(addrToUse.street);
        const adrNumber = normalizeNumberWithSuffix(addrToUse.street_number);

        const streetClose = respStreet && adrStreet && levenshtein(respStreet, adrStreet) <= 2;
        const numberMatches = respNumber === adrNumber || respNumber.startsWith(adrNumber) || adrNumber.startsWith(respNumber);


        if (streetClose && numberMatches) {
          const sameZip = (responseAddress.zip_code || '').toString().trim() && (responseAddress.zip_code || '').toString().trim() === (addrToUse.zip_code || '').toString().trim();
          const sameCity = (responseAddress.city || '').toString().toLowerCase().trim() && (responseAddress.city || '').toString().toLowerCase().trim() === (addrToUse.city || '').toString().toLowerCase().trim();
          const sameState = ((responseAddress.state_code || responseAddress.state) || '').toString().toUpperCase().trim() && ((responseAddress.state_code || responseAddress.state) || '').toString().toUpperCase().trim() === ((addrToUse.state_code || addrToUse.state) || '').toString().toUpperCase().trim();

          if (sameZip || sameCity || sameState) {
            matchingAddress = responseAddress;
            break;
          }

        }

        // geographic fallback
        const respLat = responseAddress.latitude ?? responseAddress.lat ?? responseAddress.latitude_field ?? null;
        const respLng = responseAddress.longitude ?? responseAddress.lng ?? responseAddress.longitude_field ?? null;
        if (addrToUse.lat != null && addrToUse.lng != null && respLat != null && respLng != null) {
          const toRad = (v) => v * Math.PI / 180;
          const R = 6371000;
          const dLat = toRad(respLat - addrToUse.lat);
          const dLon = toRad(respLng - addrToUse.lng);
          const a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(toRad(addrToUse.lat)) * Math.cos(toRad(respLat)) * Math.sin(dLon/2) * Math.sin(dLon/2);
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
          const distance = R * c;
          if (distance <= 50) {
            matchingAddress = responseAddress;
            break;
          }
        }
      }

      // If still no match, try a relaxed pass but only over addresses that are already marked as hotels
      if (!matchingAddress) {
        const hotelOnly = (adressResponse || []).filter(a => {
          // Handle both relationship types: hasMany (array) and belongsTo (object)
          const hasHotelArray = a.hotel && Array.isArray(a.hotel) && a.hotel.length > 0;
          const hasHotelObject = a.hotel && !Array.isArray(a.hotel) && typeof a.hotel === 'object';
          const hasHotelId = a.hotel_id != null;
          return hasHotelArray || hasHotelObject || hasHotelId;
        });
        let relaxedCount = 0;
        for (let responseAddress of hotelOnly) {
          if (relaxedCount++ > 200) break;
          
          // Apply same street-number extraction logic as main loop
          let respStreetRaw = responseAddress.street || '';
          let respNumberRaw = responseAddress.street_number || '';
          if (!respNumberRaw && respStreetRaw) {
            const matchLeading = respStreetRaw.match(/^\s*(\d+\w?)\s+[,\-]?\s*(.+)$/);
            const matchTrailing = respStreetRaw.match(/^(.+?)\s+[,\-]?\s*(\d+\w?)\s*$/);
            if (matchLeading) {
              respNumberRaw = matchLeading[1];
              respStreetRaw = matchLeading[2];
            } else if (matchTrailing) {
              respNumberRaw = matchTrailing[2];
              respStreetRaw = matchTrailing[1];
            }
          }
          
          const respStreet = normalizeStreet(respStreetRaw);
          const respNumber = normalizeNumberWithSuffix(respNumberRaw);
          const adrStreet = normalizeStreet(addrToUse.street);
          const adrNumber = normalizeNumberWithSuffix(addrToUse.street_number);

          const streetSubstring = respStreet && adrStreet && (respStreet.includes(adrStreet) || adrStreet.includes(respStreet));
          const streetFuzzy = respStreet && adrStreet && levenshtein(respStreet, adrStreet) <= 3; // slightly looser
          const numberMatches = respNumber === adrNumber || respNumber.startsWith(adrNumber) || adrNumber.startsWith(respNumber);


          if ((streetSubstring || streetFuzzy) && numberMatches) {
            matchingAddress = responseAddress;
            break;
          }
        }
      }

      if (!matchingAddress) {
        setCheckingHotel(false);
        return false;
      }

      setHotelAddress(matchingAddress);

      // Check embedded hotel relation first to avoid extra requests
      let hasHotelId = false;
      
      // Handle different relationship types
      if (matchingAddress?.hotel) {
        if (Array.isArray(matchingAddress.hotel) && matchingAddress.hotel.length > 0) {
          hasHotelId = true; // hasMany relationship
        } else if (!Array.isArray(matchingAddress.hotel) && typeof matchingAddress.hotel === 'object') {
          hasHotelId = true; // belongsTo relationship
        }
      } else if (matchingAddress?.hotel_id != null) {
        hasHotelId = true; // foreign key exists
      }

  if (matchingAddress?.hotel && Array.isArray(matchingAddress.hotel) && matchingAddress.hotel.length > 0) {
        // hasMany relationship - array of hotels
        try {
          const hid = matchingAddress.hotel[0].id;
          const cacheKey = `hotel_${hid}`;
          if (hotelLookupCache.has(cacheKey)) {
            const cached = hotelLookupCache.get(cacheKey);
            setHotel(cached);
            setCheckingHotel(false);
            return true;
          }
          if (!hotelFetchInFlight.has(cacheKey)) {
            hotelFetchInFlight.set(cacheKey, (async () => {
              try {
                const hotelResponse = await HotelService.get(hid, null, api, auth?.accessToken ? false : true);
                if (hotelResponse) hotelLookupCache.set(cacheKey, hotelResponse);
                return hotelResponse;
              } catch (e) { console.error(e); return null; } finally { hotelFetchInFlight.delete(cacheKey); }
            })());
          }
          const hotelResponse = await hotelFetchInFlight.get(cacheKey);
          if (hotelResponse) setHotel(hotelResponse);
        } catch (e) { /* ignore */ }
      } else if (matchingAddress?.hotel && !Array.isArray(matchingAddress.hotel) && typeof matchingAddress.hotel === 'object') {
        // belongsTo relationship - single hotel object
        try {
          const hid = matchingAddress.hotel.id;
          const cacheKey = `hotel_${hid}`;
          if (hotelLookupCache.has(cacheKey)) {
            const cached = hotelLookupCache.get(cacheKey);
    setHotel(cached);
    setCheckingHotel(false);
            return true;
          }
          // If we already have the full hotel object, use it directly
          if (matchingAddress.hotel.name) {
    setHotel(matchingAddress.hotel);
    hotelLookupCache.set(cacheKey, matchingAddress.hotel);
    setCheckingHotel(false);
            return true;
          }
          // Otherwise fetch the full hotel details
          if (!hotelFetchInFlight.has(cacheKey)) {
            hotelFetchInFlight.set(cacheKey, (async () => {
              try {
                const hotelResponse = await HotelService.get(hid, null, api, auth?.accessToken ? false : true);
                if (hotelResponse) hotelLookupCache.set(cacheKey, hotelResponse);
                return hotelResponse;
              } catch (e) { console.error(e); return null; } finally { hotelFetchInFlight.delete(cacheKey); }
            })());
          }
          const hotelResponse = await hotelFetchInFlight.get(cacheKey);
          if (hotelResponse) setHotel(hotelResponse);
        } catch (e) { /* ignore */ }
      } else if (matchingAddress?.hotel_id != null) {
        try {
          const hid = matchingAddress.hotel_id;
          const cacheKey = `hotel_${hid}`;
          if (hotelLookupCache.has(cacheKey)) {
            const cached = hotelLookupCache.get(cacheKey);
    setHotel(cached);
    setCheckingHotel(false);
            return true;
          }
          if (!hotelFetchInFlight.has(cacheKey)) {
            hotelFetchInFlight.set(cacheKey, (async () => {
              try {
                const hotelResponse = await HotelService.get(hid, null, api, auth?.accessToken ? false : true);
                if (hotelResponse) hotelLookupCache.set(cacheKey, hotelResponse);
                return hotelResponse;
              } catch (e) { console.error(e); return null; } finally { hotelFetchInFlight.delete(cacheKey); }
            })());
          }
          const hotelResponse = await hotelFetchInFlight.get(cacheKey);
          if (hotelResponse) setHotel(hotelResponse);
        } catch (e) { /* ignore */ }
      } else if (matchingAddress?.id) {
        // fallback: single hotel index lookup by address_id with caching/dedupe
        try {
          const addrKey = `address_${matchingAddress.id}`;
          if (hotelLookupCache.has(addrKey)) {
            const cached = hotelLookupCache.get(addrKey);
    setHotel(cached);
    setCheckingHotel(false);
            return true;
          }
          if (!hotelFetchInFlight.has(addrKey)) {
            hotelFetchInFlight.set(addrKey, (async () => {
              try {
                const hotels = await HotelService.index({ address_id: matchingAddress.id }, api, auth?.accessToken ? false : true);
                const h = Array.isArray(hotels) && hotels.length ? hotels[0] : null;
                if (h) hotelLookupCache.set(addrKey, h);
                return h;
              } catch (e) { console.error(e); return null; } finally { hotelFetchInFlight.delete(addrKey); }
            })());
          }
          const hotels = await hotelFetchInFlight.get(addrKey);
          if (hotels) { setHotel(hotels); hasHotelId = true; }
        } catch (e) {
          // ignore lookup error
        }
      }

  setCheckingHotel(false);
      return hasHotelId;
    } catch (error) {
      console.error("Erreur lors du chargement des domaines:", error);
      setCheckingHotel(false);
      return false;
    }
  };
  const handleSubmitAuth = async (event) => {
    event.preventDefault();
    const authAddress = user.user.primary_address;
    const formattedAddress = {
      ...authAddress,
      lng: authAddress.longitude,
      lat: authAddress.latitude,
    };
    delete formattedAddress.longitude;
    delete formattedAddress.latitude;
    setAddress(formattedAddress);

    const adrs = {
      address: formattedAddress,
    };
    sessionStorage.setItem('address', JSON.stringify(adrs));
    sessionStorage.setItem('state', JSON.stringify({ address: formattedAddress, phone: user?.user?.phone }));

    if (!formattedAddress.zip_code) {
  notify.warn(t('please_enter_postal_code'));
      setShowPostalField(true); // afficher le champ uniquement après submit
      return;
    }
    const isOneZone = await checkZipCodeInRange(formattedAddress.zip_code);
    if (!isOneZone) {
      notify.warn(t('zone_not_served'));
      openModal2()
      return;
    }

    // Before navigating, check if this address matches a hotel and show popup if so
    try {
      const isHotel = await checkAdress(formattedAddress);
      if (isHotel) {
        notify.warn(t('hotel_address_short'));
        openModal();
        return;
      }
    } catch (e) {
      console.error('Error checking hotel for auth address', e);
    }

    navigate('/fav-flypro', { state: { adress: formattedAddress, phone: user?.user?.phone, origin_flow: 'pro' } });

  }

  const handlePlaceSelect = (place) => {
    const addressComponents = place.address_components;
    const newAddress = {
      street: '',
      city: '',
      zip_code: '',
      street_number: '',
      state: '',
      state_code: '',
      country: 'Switzerland',
      country_code: 'CH',
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
     place_id: place.place_id,
    };
    for (const component of addressComponents) {
      const componentType = component.types[0];
      switch (componentType) {
        case 'street_number':
          newAddress.street_number = component.long_name;
          break;
        case 'route':
          newAddress.street = component.long_name;
          break;
        case 'locality':
          newAddress.city = component.long_name;
          break;
        case 'postal_code':
          newAddress.zip_code = component.long_name;
          break;
        case 'administrative_area_level_1':
          newAddress.state = component.long_name;
          newAddress.state_code = component.short_name;
          break;
      }
    }

    // Fallback: if no street_number was found but we have a formatted address,
    // try to extract it from the full address string
  if (!newAddress.street_number && place.formatted_address) {
      const fullAddress = place.formatted_address;
      // Try to extract leading number: "32, Rue du Petit-Chêne, Lausanne..."
      const leadingMatch = fullAddress.match(/^\s*(\d+\w?)\s*[,\-]?\s*(.+)$/);
      if (leadingMatch) {
        newAddress.street_number = leadingMatch[1];
      }
    }

    // Additional fallback: if we have a street name but no number, check if the street contains the number
  if (!newAddress.street_number && newAddress.street) {
      const streetWithNumber = newAddress.street.match(/^\s*(\d+\w?)\s+(.+)$/);
      if (streetWithNumber) {
        newAddress.street_number = streetWithNumber[1];
        newAddress.street = streetWithNumber[2];
      }
    }

    setAddress(newAddress);
  };
  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading Maps</div>;

  return (
    <>
      <MenuHeader />
      <div className="container ">
        <h2>{t('location:where_care')}</h2>

        {!isEditing && user?.user?.primary_address && !location.state?.fromEditBooking && sessionStorage.getItem("editBookingMode") !== "true" ? (
          <form onSubmit={handleSubmitAuth}>
            <div className="container container-profile">
              <div className="adress">
                <h3>{t('location:address')}</h3>
                <div className="rue">
                  {user?.user?.primary_address ? (
                    <>
                      {user?.user?.primary_address?.street} {user?.user?.primary_address?.street_number}
                      <br />
                      {user?.user?.primary_address?.zip_code} {user?.user?.primary_address?.city}
                    </>
                  ) : (
                    <span>Adresse non disponible</span>
                  )}
                  <br />
                  {/* {phone} */}
                </div>
                <a href="#" className="edit" onClick={handleEditClick}>Edit</a>
              </div>
            </div>
            <div className="btn-bottom">
              <button type="submit" className="btn btn-primary">
                {t('location:next')}
              </button>
            </div>
          </form>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="container-location">
              <div className="form-group">
                <label htmlFor="street">{t('location:enter_address')}</label>
                <Autocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                  onPlaceSelected={handlePlaceSelect}
                  // Use only the controlled `address` value so clicking Edit starts empty
                  defaultValue={`${address.street || ''} ${address.street_number || ''}`}
                  options={{
                    types: ['address'],
                    componentRestrictions: { country: 'CH' },
                  }}
                  style={{
                    width: '100%',
                    padding: '0 15px',
                    height: '60px',
                    border: '0',
                    borderRadius: '20px',
                    boxShadow: '0px 8px 50px 0px rgba(0, 0, 0, 0.06)',
                  }}
                />
              </div>
            </div>

            <div className="btn-bottom">
              <button type="submit" className="btn btn-primary">
                Suivant
              </button>
            </div>
          </form>
        )}

        {/* Address form for editing or when address exists */}
        {((isEditing || !user?.user || !user?.user?.primary_address) && address.lat && address.lng) && (
          <form onSubmit={handleSubmit}>
            <div className="container-location">
              <div className="form-group">
                <input
                  type="hidden"
                  id="street"
                  className="form-control"
                  value={address.street}
                  onChange={(e) => setAddress({ ...address, street: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                {/* <label htmlFor="street">Rue</label> */}
                <input
                  type="hidden"
                  id="street"
                  className="form-control"
                  value={address.street_number}
                  onChange={(e) => setAddress({ ...address, street_number: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="hidden"
                  id="state"
                  className="form-control"
                  value={address.state}
                  onChange={(e) => setAddress({ ...address, state: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                {showPostalField && (
                  <>
                    <label htmlFor="postalCode">{t('location:postal_code')}</label>
                    <input
                      type="text"
                      id="postalCode"
                      className="form-control"
                      value={address.zip_code}
                      onChange={(e) => setAddress({ ...address, zip_code: e.target.value })}
                      required
                    />
                  </>
                )}
              </div>
              <div className="form-group">
                <input
                  type="hidden"
                  id="city"
                  className="form-control"
                  value={address.city}
                  onChange={(e) => setAddress({ ...address, city: e.target.value })}
                  required
                />
              </div>
            </div>

            <div className='btn-bottom'>
              <button type="submit" className="btn btn-primary">
                {t('location:next')}
              </button>
            </div>
          </form>
        )}
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles2}
        contentLabel="Example Modal"
        id="custom-popup-content"
      >
        <div className="contentModal">
          {hotel && (!hotel.is_only_internal ? (
            <div className="modal">
              <p className="modal-text">
                {t('hotel_address_message')}
              </p>
              <h2 className="modal-hotel-name">  {hotel?.name}
                <span className="modal-rating">
                  {hotel?.extra?.google_rating?.rating ? (
                    `⭐ ${Number(hotel.extra.google_rating.rating).toFixed(1)}/5 ${hotel.extra.google_rating.user_ratings_total ? `(${hotel.extra.google_rating.user_ratings_total})` : ''}`
                  ) : hotel?.extra?.rating ? (
                    `⭐ ${hotel.extra.rating}/5`
                  ) : (
                    ''
                  )}
                </span>
              </h2>
              <p className="modal-distance">{t('hotel_distance', { distance: hotel?.distance_from_center })}</p>
              <p className="modal-address">{t('address_label')} <span className='address-detail'>{hotelAddress?.street_number} {hotelAddress?.street}, {hotelAddress?.zip_code} {hotelAddress?.city}, {hotelAddress?.country}</span></p>
            </div>
          ) : (
            <div className="modal">
              <p className="modal-text2" style={{ whiteSpace: 'pre-line' }}>
                {t('hotel_address_internal')}{' '}
                {hotel?.phone && (
                  <a href={`tel:${hotel.phone}`} style={{ color: '#faef9b' }}>
                    {hotel.phone}
                  </a>
                )}
              </p>
              <button className="modal-ok-button" onClick={closeModal}>{t('close')}</button>
            </div>
          ))}
        </div>
        {!hotel?.is_only_internal && (
          <div className="modal-button-container">
            <button className="modal-cancel-button" onClick={closeModal}>{t('cancel')}</button>
            <button className="modal-ok-button" onClick={onConfirm}>{t('ok')}</button>
          </div>
        )}
      </Modal>
      <Modal
        isOpen={modalIsOpen2}
        onRequestClose={closeModal2}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="zone-not-served-container">
          <div className="popup-box">
            <button onClick={closeModal2} className="close-btn"><img src={croix} alt="Fermer" /></button>
            <h2>{t('location:zone_not_served')}</h2>
            <p>
              {t('location:stay_informed')}
            </p>
            <form onSubmit={handleSubmitEmail}>
              <label htmlFor="email">{t('location:email_address')}</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="send-btn">{t('location:send')}</button>
            </form>
            <button onClick={onContact} className="support-btn">{t('location:contact_support')}</button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LocationPro;
